import React, { useState } from 'react';
import { GoogleLogin } from "@react-oauth/google"
import googleLogo from "../../Assets/google-logo.png";
import './SignIn.css';
import Navbar from '../Navbar/Navbar';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL;
const SignIn = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleEmailChange = (e) => setEmail(e.target.value);
  const handlePasswordChange = (e) => setPassword(e.target.value);

  const ADMIN_EMAIL = process.env.ADMIN_EMAIL;
  const ADMIN_PASSWORD =process.env.ADMIN_PASSWORD;
  console.log(API_BASE_URL);
  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const res = await fetch(`${API_BASE_URL}/api/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });

    const data = await res.json();
    if (res.ok) {
      toast.success("Login successful!");
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      localStorage.setItem("email", data.user.email);

      const redirectPath = localStorage.getItem("redirectAfterLogin") || "/";
      localStorage.removeItem("redirectAfterLogin");

      setTimeout(async () => {
        if (email === ADMIN_EMAIL && password === ADMIN_PASSWORD) {
          navigate("/admin-dashboard");
        } else if (redirectPath === "/BuildChatBot") {
          try {
            // 🔍 Check if the user has submitted the form
            const check = await fetch(`${API_BASE_URL}/api/auth/get-by-email/${email}`);
            const formData = await check.json();
            if (check.ok && formData._id) {
              // 🚀 Form exists → go to dashboard
              navigate("/dashboard");
            } else {
              // 📝 No form yet → let them build
              navigate("/BuildChatBot");
            }
          } catch (err) {
            console.error("Error checking form status:", err);
            navigate("/BuildChatBot"); // fallback
          }
        } else {
          navigate(redirectPath);
        }
      }, 1000);
    } else {
      toast.error(data.message || "Login failed");
    }
  } catch (error) {
    console.error(error);
    toast.error("Server error. Please try again.");
  }
};
 const handleGoogleSuccess = async (credentialResponse) => {
    try {
      const idToken = credentialResponse?.credential;
      if (!idToken) {
        toast.error("Google token not received.");
        return;
      }

      const res = await fetch(`${API_BASE_URL}/api/auth/google`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ credential: idToken }),
      });

      const data = await res.json();

      if (!res.ok) {
        toast.error(data.message || "Google login failed");
        return;
      }

      toast.success("Login successful!");
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      localStorage.setItem("email", email);

      const redirectPath = localStorage.getItem("redirectAfterLogin") || "/";
      localStorage.removeItem("redirectAfterLogin");
      navigate(redirectPath);
    } catch (err) {
      console.error(err);
      toast.error("Server error. Please try again.");
    }
  };

  const handleGoogleError = () => {
    toast.error("Google sign-in failed");
  };

  return (
    <>
      <Navbar />
      <div className="signin-container">
        <div className="signin-box">
          <h2>Sign in to your XenaChat account</h2>

           <div style={{ display: "flex", justifyContent: "center" }}>
            <GoogleLogin onSuccess={handleGoogleSuccess} onError={handleGoogleError} />
          </div>

          <div className="separator">
            <span>or</span>
          </div>

          <form onSubmit={handleSubmit}>
            <label htmlFor="email" className="form-label">Email</label>
            <input
              id="email"
              type="email"
              className='signInEmail'
              placeholder="Enter email address"
              value={email}
              onChange={handleEmailChange}
              required
            />

            <label htmlFor="password" className="form-label">Password</label>
            <input
              id="password"
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={handlePasswordChange}
              required
            />

          

            <button type="submit" className="submit-button" disabled={!email}>
              Continue with Email
            </button>
          </form>

          <p className="signup-text">
            Don’t have an account yet? <a href="/SignUp">Sign Up</a>
          </p>
        </div>
      </div>
    </>
  );
};

export default SignIn;
